import { useQuery } from '@tanstack/react-query';

import { payCalendarsService, individualsService, PayCalendar } from '@aslanpay/portal-common-lib';

export const fetchPayCalendarQuery = (id?: string) => ({
  queryKey: ['fetchPayCalendar', id],
  queryFn: async () => {
    const payCalendar = await payCalendarsService.fetchPayCalendar(id || '');

    const employees = await individualsService.fetchIndividuals({
      role: ['EMPLOYEE'],
      payCalendarId: [payCalendar.id],
      page: 0,
      size: 999999,
    });

    const hasEmployeeWithSalary = employees.list.some(
      (employee) => employee.annualGrossSalary !== null
    );

    return { ...payCalendar, employees: employees.list.length, hasEmployeeWithSalary };
  },
  enabled: !!id,
});

const useFetchPayCalendar = (id?: string) => {
  return useQuery<PayCalendar & { employees: number }, Error>(fetchPayCalendarQuery(id));
};

export default useFetchPayCalendar;
